$(document).ready(function () { 
  $(document).on('click', '.js-toggle_tab', function (e) {
    e.preventDefault();

    let Tabs = $(this).closest('.Section_Tabs'),
        tab_id = $(this).attr('aria-controls');

    Tabs.find('.js-toggle_tab').removeClass('is_active');
    Tabs.find('.js-toggle_tab').attr('aria-selected', 'false');
    Tabs.find('.TabPanel').attr('aria-hidden', 'true');

    $(this).addClass('is_active');
    $(this).attr('aria-selected', 'true');
    $('#' + tab_id).attr('aria-hidden', 'false');
  });

  $(document).on('click', '[data-accordion-trigger]', function (e) {
    e.preventDefault();

    var Collapsible = $(this).closest('[data-accordion-section]');

    var parentCollapsible = $(this).closest('[data-accordion]');
    var collapsibleInner = parentCollapsible.find('[data-accordion-content]');

    if ($(this).attr('aria-expanded') === 'false') {
      Collapsible.find('[data-accordion-trigger]').attr('aria-expanded', 'false');
      Collapsible.find('[data-accordion-content]').slideUp();

      $(this).attr('aria-expanded', 'true');
      collapsibleInner.slideDown();

    } else {
      $(this).attr('aria-expanded', 'false');
      collapsibleInner.slideUp();
    }
  });

  $(document).on('change', '.js-caculator_usage', function (e) {
    e.preventDefault();

    let usage = $(this).find(":selected").attr('data-usage');

    $('.js-usage_result').html(usage);
  });

  if ($('body').hasClass("template_page_faq")) {
    let FaqContact = $('.template_page_faq .FaqContact'),
        FaqContent = $('.template_page_faq .Faq'),
        PageLayout__Sidebar = $('.template_page_faq .PageLayout__Sidebar');
    if (window.innerWidth < 750) { 
      FaqContent.append(FaqContact);
    }else{
      PageLayout__Sidebar.append(FaqContact);
    }
  }
});

class FaqSection extends HTMLElement { 
  constructor() {
    super();
    
    this.currentScrollTop = 0;
    this.FaqSummary = this.querySelector('.FaqSummary_List');
    this.ButtonFaqSummary = this.querySelector('[data-action="open-FaqSummary"]');
    this.FaqContact = this.querySelector('.FaqContact');
    this.FaqContent = this.querySelector('.Faq');

    this.bindEvents();
  }

  bindEvents() { 
    this.querySelectorAll('.FaqSummary__Item').forEach(item => item.addEventListener('click', this.switchToCategory.bind(this)));
    this.ButtonFaqSummary.addEventListener('click', this.openFaqSummary.bind(this));

    // this.onScrollHandler = this.onScroll.bind(this);
    // window.addEventListener('scroll', this.onScrollHandler, false);
  }

  switchToCategory(event) {
    event.preventDefault();

    let FaqSummary__Item = event.currentTarget;
    let href = FaqSummary__Item.querySelector('.FaqSummary__Link').getAttribute('href');
    let headerHeight = document.querySelector('.section-header').getBoundingClientRect().bottom;
    let sidebarHeight = document.querySelector('.PageLayout__Sidebar').getBoundingClientRect().bottom;
    let FaqSummary__ItemTop = document.querySelector(href).getBoundingClientRect().top + document.documentElement.scrollTop;
    let offsetTop = 0;

    if (window.innerWidth < 750) { 
      offsetTop = FaqSummary__ItemTop - headerHeight - sidebarHeight;
    } else {
      offsetTop = FaqSummary__ItemTop - headerHeight;
    }

    this.FaqSummary.querySelectorAll('.FaqSummary__Item').forEach(item => {
      item.classList.remove('is_active');
    });
    FaqSummary__Item.classList.add('is_active');

    window.scrollTo({
      top: offsetTop,
      left: 0,
      behavior: 'smooth'
    });

    if (window.innerWidth < 750) { 
      let textActive = FaqSummary__Item.querySelector('.FaqSummary__LinkLabel').innerHTML;
      this.ButtonFaqSummary.querySelector('.ButtonFaqSummary__Text').innerHTML = textActive;

      this.FaqSummary.style.display = 'none';
      this.ButtonFaqSummary.setAttribute('aria-expanded', false);
    }
  }

  onScroll() { 
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.currentScrollTop = scrollTop;
  }

  openFaqSummary(event) {
    event.preventDefault();

    if (this.ButtonFaqSummary.getAttribute('aria-expanded') === 'false') {
      this.ButtonFaqSummary.setAttribute('aria-expanded', true);
      this.FaqSummary.style.display = 'block';
    } else {
      this.ButtonFaqSummary.setAttribute('aria-expanded', false);
      this.FaqSummary.style.display = 'none';
    }
  }
}
customElements.define('faq-section', FaqSection);

let getSiblings = function (e) {
  // for collecting siblings
  let siblings = []; 
  // if no parent, return no sibling
  if(!e.parentNode) {
      return siblings;
  }
  // first child of the parent node
  let sibling  = e.parentNode.firstChild;
  
  // collecting siblings
  while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
          siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
  }
  return siblings;
};

if(document.querySelector('.subscription-change-form')) {
  const formSubcriptionChanges = document.querySelectorAll('.subscription-change-form');
  formSubcriptionChanges.forEach(formSubcriptionChange => {
    const typePets = formSubcriptionChange.querySelectorAll('input[name="pettype-change"]');
    typePets.forEach(typePet => {
      typePet.addEventListener('change', function() {
        console.log(typePet.checked);
        if(typePet.checked) {
          const value = typePet.value;
          if(value == 'Dog') {
            console.log('Dog');
            document.querySelector('.js-weight-dogs').style.display = 'flex';
            document.querySelector('.js-weight-cats').style.display = 'none';
          } else {
            console.log('Cat');
            document.querySelector('.js-weight-cats').style.display = 'flex';
            document.querySelector('.js-weight-dogs').style.display = 'none';
          }
        }
      });
    });
  })
}
if (!customElements.get('custom-pagination')) {
	class Pagination extends HTMLElement {
	  constructor() {
	    super();
	    this.initClickHandler();
	  }

	  initClickHandler() {
	    this.querySelector('a')?.addEventListener('click', function(e) {
	      e.preventDefault();
	      e.currentTarget.parentElement.handlePaginationClick();
	    });
	  }

	  handlePaginationClick() {
	    document.querySelector('collection-grid').getProduct();
	  }
	}
	customElements.define('custom-pagination', Pagination);
}

class CollectionGrid extends HTMLElement {
	constructor() {
		super();

		this.method = this ? this.getAttribute("data-method") : 0;
		this.loader = document.querySelector('#AjaxinatePagination');
		this.loading = false;
		this.init();
	}

	init() {
        this.addScrollListener();
		if (this.method == 'scroll') {
			this.addScrollListener();
		}
		if(document.querySelector('#banner-collection')){
			this.insertBanner();
			this.insertSeparate();
		}
	}

	insertBanner() {
		const banner = document.querySelector('#banner-collection');
		if (!banner || document.querySelector('#banner-item')) {
			return;
		}
		let pos = document.querySelector('.metafield-banner-collection').getAttribute('data-row');
		banner.style.display = 'none';
		let grid = this.querySelector('#product-grid');
		let div = document.createElement('div');
		div.setAttribute('id', 'banner-item');
		div.innerHTML = banner.innerHTML;
		let self = this;
		let countItems = this.querySelectorAll('div.grid__item').length;
		for (var i = 0; i < countItems; i++) {
			if (countItems < pos*4 && i == (countItems - 1)) {
				self.insertAfter(div, this.querySelectorAll('div.grid__item')[i]);
			} else if(countItems >= pos*4 && i == (pos*4 - 1)) {
				self.insertAfter(div, this.querySelectorAll('div.grid__item')[i]);
			}
		}
	}

	insertAfter(newNode, existingNode) {
        existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    }
    insertSeparate(){
		let countItems = this.querySelectorAll('div.grid__item').length;
		let self = this;
		var div = document.createElement('div');
			div.setAttribute('class', 'border-item');
		for (var i = 1; i <= countItems; i++) {
			if (i % 4 == 0) {
				self.insertBefore(div.cloneNode(true), this.querySelectorAll('div.grid__item')[i]);
			}
		}
    }
	addScrollListener() {
		if (this.loader) {
			document.addEventListener("scroll", this.paginationInView.bind(this));
			window.addEventListener("resize", this.paginationInView.bind(this));
			window.addEventListener(
        "orientationchange",
        this.paginationInView.bind(this)
			);
		}
	}

	paginationInView() {
		var top = this.loader.getBoundingClientRect().top - 100;
		var bottom = this.loader.getBoundingClientRect().bottom + 100;
		if (top <= window.innerHeight && bottom >= 0 && !this.loading) {
			this.getProduct();
		}
	}

	getProduct() {
		this.nextPageLinkElement = this.loader.querySelector("a");
		this.loading = true;
		if (this.nextPageLinkElement) {
			this.nextPageLinkElement.innerHTML = 'Loading...';
			this.nextPageUrl = this.nextPageLinkElement.href;
			if (this.nextPageUrl) {
				fetch(this.nextPageUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const html = responseText;
						this.insertAdjacentHTML('beforeEnd',
							new DOMParser()
								.parseFromString(html, "text/html")
								.querySelector("#product-grid").innerHTML)
						this.loader.innerHTML = 
							new DOMParser()
								.parseFromString(html, "text/html")
								.querySelector("#AjaxinatePagination").innerHTML;
            this.loader.initClickHandler();
						this.loading = false;
						this.init();

					});
			}
		}
	}
}

customElements.define("collection-grid", CollectionGrid);

if (document.querySelector('.js-check-type')){
  const tabCollections = document.querySelectorAll('.js-check-type');
  tabCollections.forEach((tabCollection) => {
    tabCollection.addEventListener('click', () => {
      tabCollections.forEach((tabCollection) => {
        if(tabCollection.classList.contains('no-filter')) {
          tabCollection.classList.remove('no-filter');
        }
      });
    });
  });
}

const inputRadios = document.querySelectorAll('.js-check-type input');
const allTabs = document.querySelectorAll('.facets__item--first');
inputRadios.forEach((input) => {
  if(input) {
    if(input.checked) {
      allTabs.forEach((allTab) => {
        if(allTab.classList.contains('no-filter')){
          allTab.classList.remove('no-filter')
        }
      });
    }
  }
});


if (!customElements.get('read-more-line-clamp')) {
	class Readmorelineclamp extends HTMLElement {
	  constructor() {
	    super();
	    const content = this.querySelector('.js-content');
      const button = this.querySelector('.js-button-readmore');
      const textHeight = content.scrollHeight;
      if (textHeight > 96) {
        button.style.display = "inline-block";
      } else {
        button.style.display = "none";
      }
      if(button) {
        button.addEventListener('click', () => {
          button.classList.toggle('is-active');
          if(content.classList.contains('multicolumn-card__text--has-line-clamp')) {
            content.classList.remove('multicolumn-card__text--has-line-clamp');
            content.classList.add('multicolumn-card__text--no-line-clamp');
          } else {
            content.classList.remove('multicolumn-card__text--no-line-clamp');
            content.classList.add('multicolumn-card__text--has-line-clamp');
          }
        });
      }
	  }
	}
	customElements.define('read-more-line-clamp', Readmorelineclamp);
}